import { PageIntro } from "../components/site/PageIntro";
import { ImgReveal, FadeUp } from "../components/site/Reveal";
import { Btn } from "../components/site/Btn";
import { useSeo } from "../components/site/Seo";
import { useLang } from "../i18n/lang";
import { useSiteImages } from "../lib/siteImages";

const IMGS = [
  ["bespoke_tables_1", "bespoke_tables_2"],
  ["bespoke_consoles"],
  ["bespoke_sculptural"],
  ["bespoke_commissions_1", "bespoke_commissions_2"],
];

export default function Bespoke() {
  const { t, to } = useLang();
  const img = useSiteImages();
  useSeo(...t.seo.bespoke);
  return (
    <main data-testid="bespoke-page">
      <PageIntro n={0} label={t.bespoke.label} title={t.bespoke.title} text={t.bespoke.text} testid="bespoke-intro" />
      <p className="px-6 sm:px-10 lg:px-14 -mt-6 mb-16 f-mono text-[0.7rem] tracking-[0.08em] text-[#555555]">{t.bespoke.note}</p>
      {t.bespoke.cats.map(([title, text], i) => {
        const imgs = IMGS[i];
        const flip = i % 2 === 1;
        return (
          <section key={title} className="px-6 sm:px-10 lg:px-14 py-16 sm:py-24 border-t border-[#1A1A1A]/12" data-testid={`bespoke-cat-${i}`}>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-start">
              <div className={`lg:col-span-4 ${flip ? "lg:order-2 lg:col-start-9" : ""} lg:sticky lg:top-32`}>
                <p className="f-mono text-xs text-[#555555]">0{i + 1}</p>
                <h2 className="f-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-[-0.02em] mt-4 leading-[1]">{title}</h2>
                <FadeUp><p className="mt-6 text-lg leading-[1.75] text-[#3A3A3A] max-w-md">{text}</p></FadeUp>
                <div className="mt-8"><Btn to={to("/start-a-project")} variant="outline" testid={`bespoke-cta-${i}`}>{t.bespoke.cta}</Btn></div>
              </div>
              <div className={`lg:col-span-7 ${flip ? "lg:order-1" : "lg:col-start-6"} grid gap-6 ${imgs.length > 1 ? "grid-cols-1 sm:grid-cols-5" : "grid-cols-1"}`}>
                {imgs.map((key, j) => (
                  <figure key={key} className={imgs.length > 1 ? (j === 0 ? "sm:col-span-3" : "sm:col-span-2 sm:mt-24") : ""}>
                    <ImgReveal src={img(key)} alt={`${title} — ${t.common.inspiration}`} className={imgs.length > 1 ? "aspect-[3/4]" : "aspect-[4/3]"} delay={j * 0.12} />
                    <figcaption className="mt-3 f-mono text-[0.68rem] text-[#555555]">{t.common.inspiration}</figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </section>
        );
      })}
    </main>
  );
}
